import { createLogger } from 'logger-js'
import { ROUTE, ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import loadSectionAction from 'modules/section/actions/load'

const logger = createLogger({
  label: 'loadHomeSSRAction'
})

/**
 * Loads the recommended articles, motivations and products.
 * @param  {Object} route
 * @param  {Object} match
 * @param  {Object} [options={}]
 * @returns {Function}
 */
function loadHomeSSRAction (route, match, options = {}) {
  return (dispatch) => {
    logger.debug('[start]')
    return dispatch(
      loadSectionAction(ROUTE[ROUTE_PATH.ARTICLES], match, options)
    )
  }
}

export {
  loadHomeSSRAction
}
